module.exports = __webpack_public_path__ + "img/Seplember.7413389c.png";